/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AggregierteAuswertungSpalteDto } from '../../models/aggregierte-auswertung-spalte-dto';

export interface GetAllAggregierteAuswertungSpalten$Plain$Params {
}

export function getAllAggregierteAuswertungSpalten$Plain(http: HttpClient, rootUrl: string, params?: GetAllAggregierteAuswertungSpalten$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AggregierteAuswertungSpalteDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllAggregierteAuswertungSpalten$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AggregierteAuswertungSpalteDto>>;
    })
  );
}

getAllAggregierteAuswertungSpalten$Plain.PATH = '/v1/aggregierteAuswertung/layouts/spalten';
